// extracted by mini-css-extract-plugin
module.exports = {"background-color":"#F2F2F2","backgroundColor":"#F2F2F2","carousel":"_3U6Wa"};